import TextareaAutosize from 'react-textarea-autosize';
import { ICourse, ICourseCertificate, ICreateCourseCertificate } from '@/types/courses';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

type Props = {
  savingCertificate: boolean;
  course: ICourse | null;
  workingCertificate: ICourseCertificate | ICreateCourseCertificate | undefined;
  handleCertificateEmailSubjectChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleCertificateEmailBodyChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  setShowEmailPreviewModal: (show: boolean) => void;
  setEditDesignModalOpen: (open: boolean) => void;
  saveCertificate: () => Promise<void>;
};
export default function CertificatePanel({
  course,
  workingCertificate,
  savingCertificate,
  handleCertificateEmailSubjectChange,
  handleCertificateEmailBodyChange,
  setEditDesignModalOpen,
  setShowEmailPreviewModal,
  saveCertificate,
}: Props) {
  return (
    <Container
      data-testid={`course-edit-certificate-tab`}
      className="certificate-tab-container padding-16 flex gap-16"
      style={{
        display: 'grid',
        gridTemplateColumns: '320px 1fr',
      }}
    >
      <Container background="var(--gray-900)" className="padding-20 flex-column gap-10 radius-12">
        <Text className="H6" color="var(--gray-100)">
          Design
        </Text>
        {course?.certificate?.design?.thumbnail ? (
          <Container background="var(--gray-900)" maxHeight="160px">
            <Button
              width="100%"
              height="100%"
              disabled={savingCertificate}
              className="padding-0"
              onClick={() => setEditDesignModalOpen(true)}
              data-testid={`course-edit-certificate-design-edit-btn`}
            >
              <img
                src={course.certificate.design.thumbnail}
                className="width-100-percent height-100-percent radius-8 cursor-pointer object-fit-cover"
              />
            </Button>
          </Container>
        ) : (
          <Button
            width="100%"
            height="100%"
            className="flex ai-center jc-center radius-8"
            border={`1px dashed ${getThemeColorCSSVariable()}`}
            onClick={() => setEditDesignModalOpen(true)}
            data-testid={`course-edit-certificate-design-choose-btn`}
          >
            <Text color={getThemeColorCSSVariable()} className="flex ai-center gap-8">
              <Icon name={ICONS.PHOTO} />
              <Text className="L2">Choose Design</Text>
            </Text>
          </Button>
        )}
      </Container>
      <Container background="var(--gray-900)" className="email-container padding-20 flex-column gap-10 radius-12">
        <div className="flex ai-center jc-space-between">
          <Text className="H6" color="var(--gray-100)">
            Email
          </Text>
          <Button
            className="small no-style no-padding flex ai-center gap-8"
            data-testid={`course-edit-certificate-preview-btn`}
            disabled={!workingCertificate}
            onClick={() => setShowEmailPreviewModal(true)}
          >
            <Icon name={ICONS.VIEWERS_EYE} size={16} color={getThemeColorCSSVariable()} />
            <div>
              <Text color={getThemeColorCSSVariable()} className="L2">
                Preview
              </Text>
            </div>
          </Button>
        </div>
        <div>
          <Text className="L3" color="var(--gray-400)">
            SUBJECT
          </Text>
          <TextareaAutosize
            className="S2"
            placeholder={workingCertificate ? 'Enter email subject' : 'Choose a design first'}
            value={workingCertificate?.email_subject.base ?? ''}
            onChange={handleCertificateEmailSubjectChange}
            onBlur={saveCertificate}
            disabled={savingCertificate || !workingCertificate}
            data-testid={`course-edit-certificate-email-subject-input`}
            onKeyDown={(e) => (e.key === 'Enter' ? e.preventDefault() : null)}
          />
        </div>
        <div>
          <Text className="L3" color="var(--gray-400)">
            EMAIL MESSAGE
          </Text>
          <TextareaAutosize
            className="S2"
            placeholder={workingCertificate ? 'Enter email message' : 'Choose a design first'}
            value={workingCertificate?.email_body.base ?? ''}
            onChange={handleCertificateEmailBodyChange}
            onBlur={saveCertificate}
            disabled={savingCertificate || !workingCertificate}
            data-testid={`course-edit-certificate-email-body-input`}
          />
        </div>
      </Container>
    </Container>
  );
}
